const searchTrigger = document.querySelector('.search-trigger');
const searchOverlay = document.querySelector('.search-overlay');
const searchClose = document.querySelector('.search-overlay__close');
const searchField = document.querySelector('.search-field');
const searchForm = document.querySelector('.search-form');
const popularPostsSection = document.querySelector('.search-overlay__popular');

/**
 * Gets the API prefix based on the current language.
 * Returns an empty string for English ('en') or the language code as a path prefix for other languages.
 * @returns {string} The API prefix path (e.g. '/fr' for French, '' for English)
 */
function getApiPrefix() {
  const lang = document.documentElement.lang || 'en'; // fallback to 'en' if not set
  return lang === 'en' ? '' : `/${lang}`;
}

const langCode = getApiPrefix();

if (searchTrigger && searchOverlay && searchClose) {
  // Open overlay when clicking the search trigger
  searchTrigger.addEventListener('click', () => {
    searchOverlay.classList.add('is-active');
    document.body.style.overflow = 'hidden';

    // Focus the search field after ensuring the overlay is visible
    if (searchField) {
      // Use a small timeout to ensure the overlay is fully visible
      setTimeout(() => {
        searchField.focus();
        // Select any existing text in the search field
        searchField.select();
      }, 100);
    }
  });

  // Close overlay
  searchClose.addEventListener('click', () => {
    searchOverlay.classList.remove('is-active');
    document.body.style.overflow = '';
    // Return focus to the trigger button
    searchTrigger.focus();
  });

  // Close on escape key
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && searchOverlay.classList.contains('is-active')) {
      searchOverlay.classList.remove('is-active');
      document.body.style.overflow = '';
      // Return focus to the trigger button
      searchTrigger.focus();
    }
  });

  // Close on click outside
  searchOverlay.addEventListener('click', (e) => {
    if (e.target === searchOverlay) {
      searchOverlay.classList.remove('is-active');
      document.body.style.overflow = '';
      // Return focus to the trigger button
      searchTrigger.focus();
    }
  });

  // Handle search form submission
  if (searchForm) {
    searchForm.addEventListener('submit', async (e) => {
      e.preventDefault();
      const searchQuery = searchField.value.trim();

      if (!searchQuery) {
        return;
      }

      try {
        // Show loading state
        popularPostsSection.innerHTML = '<div class="search-overlay__loading">Searching...</div>';

        const response = await fetch(
          `${window.location.origin}${langCode}/wp-json/wp/v2/posts?search=${encodeURIComponent(
            searchQuery,
          )}&per_page=10&_embed&orderby=relevance`,
          {},
        );

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const posts = await response.json();

        // Update the content with search results
        if (posts.length > 0) {
          popularPostsSection.innerHTML = `
                        <div class="search-overlay__header">
                            <div class="search-overlay__results-count">Showing top ${
                              posts.length
                            } results for <span>"${searchQuery}"</span></div>
                            <a href="${window.location.origin}${langCode}/?s=${encodeURIComponent(
            searchQuery,
          )}" class="search-overlay__see-all">See All Results</a>
                        </div>
                        <div class="search-overlay__popular-posts">
                            ${posts
                              .map(
                                (post) =>
                                  `
                                <article class="post-list-item">
                                    <a href="${post.link}" aria-label="${
                                    post.title.rendered
                                  }" class="post-list-item__link">
                                        <div class="post-list-item__thumbnail">
                                            <div class="post-list-item__thumbnail__wrapper">
                                                ${
                                                  post._embedded?.['wp:featuredmedia']?.[0] // eslint-disable-line no-underscore-dangle
                                                    ?.source_url
                                                    ? `<img src="${post._embedded['wp:featuredmedia'][0].source_url}" alt="${post.title.rendered}">` // eslint-disable-line no-underscore-dangle
                                                    : `<img src="${fallbackFeaturedImage.imageUrl}" alt="${post.title.rendered}">` // eslint-disable-line no-undef
                                                }
                                            </div>
                                        </div>
                                        <div class="post-list-item__main">
                                            <div class="post-list-item__meta">
                                                <span class="post-list-item__meta__category">${
                                                  post.category_names[0] || ''
                                                }</span>
                                                <span class="post-list-item__meta__date">${new Date(
                                                  post.modified,
                                                ).toLocaleDateString('en-US', {
                                                  month: '2-digit',
                                                  day: '2-digit',
                                                  year: 'numeric',
                                                })}</span>
                                            </div>
                                            <div class="post-list-item__title">
                                                ${post.title.rendered}
                                            </div>
                                            <div class="post-list-item__excerpt">
                                                ${post.excerpt.rendered}
                                            </div>
                                        </div>
                                    </a>
                                </article>
                            `,
                              )
                              .join('')}
                              <div class="search-overlay__see-all-button">

                                <a href="${
                                  window.location.origin
                                }${langCode}/?s=${encodeURIComponent(
            searchQuery,
          )}" class="button button--primary">
                                                              See All Results</a>
                              </div>
                
                        </div>
                    `;
        } else {
          popularPostsSection.innerHTML = `
                        <h3>No Results Found</h3>
                        <p>Try different keywords.</p>
                    `;
        }
      } catch (error) {
        popularPostsSection.innerHTML = `
                    <h3>Error</h3>
                    <p>Something went wrong. Please try again.</p>
                `;
      }
    });
  }
}
